module.exports = __webpack_public_path__ + "img/cart.0b73a5cc.svg";